import { createI18n } from 'vue-i18n';

import * as enTranslations from '@/assets/translations/en';
import * as frTranslations from '@/assets/translations/fr';
import * as jaTranslations from '@/assets/translations/ja';
import * as zhTranslations from '@/assets/translations/zh-cn';

import { getLocale } from '@/helpers';

// Define an interface for nested translation objects
interface TranslationValue {
  [key: string]: string | TranslationValue;
}

// Utility function to merge translations
const mergeTranslations = (translations: Record<string, TranslationValue>) =>
  Object.values(translations).reduce((acc, val) => ({ ...acc, ...val }), {});

const fr = mergeTranslations(frTranslations);
const en = mergeTranslations(enTranslations);
const ja = mergeTranslations(jaTranslations);
const zh = mergeTranslations(zhTranslations);

const messages = { fr, en, ja, zh };

export const i18n = createI18n({
  globalInjection: true,
  legacy: false, // set to `false` to use Composition API
  locale: getLocale(),
  fallbackLocale: 'en',
  messages
});
